import { render, staticRenderFns } from "./ProgrammVideos.vue?vue&type=template&id=693e32b0&scoped=true&"
import script from "./ProgrammVideos.vue?vue&type=script&lang=js&"
export * from "./ProgrammVideos.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammVideos.vue?vue&type=style&index=0&id=693e32b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693e32b0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/ProgrammVideos.vue
// module id = null
// module chunks = 